import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "@environments/environment";

import { ShareMessageResponse } from "@shared/Interfaces/share-message-response.interface";
import { ParamsService } from "@shared/Services/params.service";

const { enlineaBackendUrl } = environment;

import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";

import { AccountStatementFilter, AccountStatementReportFilter } from "../Types/Interfaces/account-statement-filter.interface";
import { AccountStatement, AccountStatementEmail } from "../Types/Interfaces/account-statement.interface";

@Injectable({
  providedIn: "root",
})
export class AccountStatementRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getStatementsDropdown(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/insurances/AccountStatements/AccountStatementsTypes`);
  }

  public getAccountStatement(accountStatementFilter: AccountStatementFilter): Observable<AccountStatement[]> {
    const params = this.paramsService.mapRequestParams(accountStatementFilter);
    return this.http.get<AccountStatement[]>(`${enlineaBackendUrl}/api/insurances/AccountStatements`, { params }).pipe(
      map((getStatements) => {
        return getStatements.map((AccountStatement) => ({
          ...AccountStatement,
          customerInformation: {
            ...AccountStatement.customerInformation,
            cliente: `${AccountStatement.customerInformation?.firstName || ""} ${
              AccountStatement.customerInformation?.lastName || ""
            }`,
          },
          policyInformation: {
            ...AccountStatement.policyInformation,
            policyFormatted: `${AccountStatement.policyInformation?.productCode || ""}-${
              AccountStatement.policyInformation?.policyNumber || ""
            }`,
          },
        }));
      })
    );
  }

  public getAccountStatementReport(accountStatementReportFilter: AccountStatementReportFilter): Observable<Blob> {
    const params = this.paramsService.mapRequestParams(accountStatementReportFilter);
    return this.http.get<Blob>(`${enlineaBackendUrl}/api/insurances/AccountStatements/Report`, {
      params,
      responseType: "blob" as "json",
    });
  }

  public sendEmailNotification(request: AccountStatementEmail): Observable<ShareMessageResponse> {
    return this.http.post<ShareMessageResponse>(`${enlineaBackendUrl}/api/insurance/accountstatement/email`, request);
  }
}
